import "../styles/contact.css"


function Contact() {
	return (
	  <div className="contact">
	    <h1>Contact</h1>
	    <h3>Email: sonalprasad.sp@gmail.com</h3>
	    <h3>LinkedIn Profile: <a href="https://www.linkedin.com/in/sonalprasad/" target="_blank" rel="noreferrer">https://www.linkedin.com/in/sonalprasad/</a></h3>
	    <h3>Github Profile: <a href="https://github.com/sprasad123" target="_blank" rel="noreferrer">https://github.com/sprasad123</a></h3>
	  </div>
	);
}

export default Contact;